/*global ns2_ */
'use strict';

var statsUtil = require('../util/stats');
import * as domUtils from '../util/dom';
var device = require('../util/device');
var VideoConfig = require('../config');
var Sizzle = require('sizzle');
var Debug = require('../util/debug')('mms-stats');
var ns_ = require('../ext/statistics/streamsense_plugin_html5');

module.exports = {
    namespace: 'mms',

    create: function (api) {

        var settings = {
            metadata: undefined,
            isPiPMode: false,
            isAirplayMode: false
        };

        var _getElement = function () {
            return Sizzle('video', api.element())[0];
        };

        api.on(this.namespace + '.metadata', function (data) {
            settings.metadata = data.detail;
        // });
        //
        // api.on(this.namespace + '.ready', function () {
            const videoElement = _getElement();

            if (settings.metadata && settings.metadata.mmsStatistics && videoElement !== undefined) {
                const programId = settings.metadata.mmsStatistics.mms_tid || '000000';
                const programTitle = settings.metadata.mmsStatistics.ns_st_pr || 'unknown_program';
                const episodeTitle = settings.metadata.mmsStatistics.ns_st_ep || 'unknown_episode';
                const tags = settings.metadata.mmsStatistics.svt_taggar || '';

                if (!api.streamSense) {
                    Debug('Creating new StreamSense object');
                    api.streamSense = new ns_.StreamSense.Html5(videoElement, {
                        logurl: statsUtil.getScorecardResearchUrl()
                    });
                }

                let mmsData = {
                    c2: statsUtil.getComscoreC2Value(),
                    ns_site: statsUtil.getComscoreSite(),
                    ns_st_mp: 'HTML5',
                    ns_st_mv: 'svtvideoplayer-HTML5',
                    mms_clnr: statsUtil.getMmsClientNr(),
                    mms_tid: programId,
                    mms_subsite: 'svtplay.html5',
                    svt_app: 'webb',
                    svt_contenttype: settings.metadata.mmsStatistics.svt_contenttype,
                    client: statsUtil.getClient(),
                    name: statsUtil.getClient() + '.' + programTitle + '.' + episodeTitle,
                    svt_taggar: tags
                };

                if (window.SVT_STATISTICS && window.SVT_STATISTICS.contextData) {
                    const contextData = window.SVT_STATISTICS.contextData;

                    mmsData.svt_domain = contextData.svt_domain;
                    mmsData.svt_level1 = contextData.svt_level1;
                    mmsData.svt_level2 = contextData.svt_level2;
                    mmsData.svt_level3 = contextData.svt_level3;
                    mmsData.svt_pagename = `${mmsData.svt_domain}:${mmsData.svt_level1}:${mmsData.svt_level2}:${mmsData.svt_level3}`;

                    if (contextData.svt_appname && contextData.svt_appname !== 'webb') {
                        mmsData.svt_app = 'app';
                    }
                }

                api.streamSense.setLabels(mmsData);

                api.streamSense.setPlaylist({
                    ns_st_pl: settings.metadata.mmsStatistics.ns_st_pl
                });

                api.streamSense.setClip({
                    ns_st_pr: programTitle,
                    ns_st_ep: episodeTitle,
                    ns_st_cl: settings.metadata.mmsStatistics.ns_st_cl,
                    ns_st_li: settings.metadata.live || settings.metadata.simulcast ? 1 : 0
                });
            }
        });

        api.once(this.namespace + '.playing', function () {
            if (device.isPictureInPictureCapable(_getElement())) {
                this.isPiPMode = api.video().webkitPresentationMode === 'picture-in-picture';
                api.streamSense.setLabel('svt_pip', settings.isPiPMode);

                domUtils.addEvents(_getElement(), 'webkitpresentationmodechanged', function (e) {
                    settings.isPiPMode = api.video().webkitPresentationMode === 'picture-in-picture';
                    api.streamSense.setLabel('svt_pip', settings.isPiPMode);
                }, settings.namespace);
            }

            if (device.isAirplayCapable()) {
                this.isAirplayMode = api.video().webkitCurrentPlaybackTargetIsWireless;
                api.streamSense.setLabel('svt_exscreen', settings.isAirplayMode);

                domUtils.addEvents(_getElement(), 'webkitcurrentplaybacktargetiswirelesschanged', function () {
                    settings.isAirplayMode = api.video().webkitCurrentPlaybackTargetIsWireless;
                    api.streamSense.setLabel('svt_exscreen', settings.isAirplayMode);
                }, settings.namespace);
            }
        });

    },

    destroy: function (api) {
        //api.off(this.namespace + '.ready');
        api.off(this.namespace + '.metadata');
        domUtils.removeEvents(Sizzle('video', api.element())[0], 'webkitpresentationmodechanged', this.namespace);
        domUtils.removeEvents(Sizzle('video', api.element())[0], 'webkitcurrentplaybacktargetiswirelesschanged', this.namespace);

        api.streamSense = undefined;
    }
};



// WEBPACK FOOTER //
// ./src/js/plugins/mms-stats.js